module.exports = __webpack_public_path__ + "img/staysure-logo-strapline.f1ec8b13.png";